import clickOk from '../sounds/click_ok.mp3';

// NUMBERS
import numbersPracticeInstructionStart
    from '../sounds/ran_numbers_practice_instruction_start.mp3';
import numbersItemOne from '../sounds/ran_numbers_seven.mp3';
import numbersItemTwo from '../sounds/ran_numbers_nine.mp3';
import numbersItemThree from '../sounds/ran_numbers_four.mp3';
import numbersItemFour from '../sounds/ran_numbers_one.mp3';
import numbersItemFive from '../sounds/ran_numbers_six.mp3';
import numbersPracticeInstructionGeneral
    from '../sounds/ran_numbers_practice_instruction_general.mp3';
import numbersPracticeReadyInstruction
    from '../sounds/ran_numbers_practice_ready_instruction.mp3';

const RAN_AUDIO_INSTRUCTIONS = {
    numbers: {
        practiceInstructionStart: numbersPracticeInstructionStart,
        autoplayInstructions: [
            numbersItemOne,
            numbersItemTwo,
            numbersItemThree,
            numbersItemFour,
            numbersItemFive,
        ],
        practiceInstructionGeneral: numbersPracticeInstructionGeneral,
        practiceReadyInstruction: numbersPracticeReadyInstruction,
    },
    clickOk,
};

export const RAN_ACTIVITY_TIMER = 'RANActivityTimer';

export default RAN_AUDIO_INSTRUCTIONS;
